import React, { useState , useContext} from "react";
import Select from '@mui/material/Select';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  TextField,
  Stack,
  Typography,
  Avatar,
  Grid,
  MenuItem, 
} from '@mui/material';
import { Radio, RadioGroup, FormControlLabel } from '@mui/material';
import { UserContext } from '../../context/UserContext'
import { Snackbar } from '@mui/material';
import { BASE_URL } from "../../baseUrl"

const FormRequestKeys = ({ open }) => {

  /*Variables form*/
  const [name, setName] = useState('');
  const [entitytype, setEntityType] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [numberusers, setNumberUsers]= useState(0);
  const [numberuserserror, setNumberUsersError]= useState('');
  const [numberprivate, setNumberPrivate] = useState('');
  const [numberprivateerror, setNumberPrivateError] = useState('');
  const [sector, setSector] = useState('');
  const [login] = useContext(UserContext);
  const currentDate = new Date();
  const dateString = currentDate.toISOString().split('T')[0];
  // State for Snackbar visibility and message
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const handleSectorChange = (event) => {
    cleanFormData()
    setSector(event.target.value);
  };

  const handleEntityTypeChange = (event) => {
    setEntityType(event.target.value);
  };

  /*clean up variables*/

  const cleanFormData = () => {
    setName("");
    setEntityType("");
    setCity("");
    setState("");
    setNumberUsers(0);
    setNumberPrivate(0);
  };
  // Function to close Snackbar
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleUserCountChange = (event) => {
    const value = event.target.value;
    if (value > 3) {
      setNumberUsersError('Maximum number allowed is 3');
    } else {
      setNumberUsersError('');
    }
    setNumberUsers(value);
  };

  const handleUserCountChange2 = (event) => {
    const value = event.target.value;
    if (value > 3) {
      setNumberPrivateError('Maximum number allowed is 3');
    } else {
      setNumberPrivateError('');
    }
    setNumberPrivate(value);
  };

  /*Insert a new entry*/
  const submitRequestKey = async () => {
    let body;
    let url_api;

    if (sector === 'public') { // Use '===' for comparison instead of '='
      body = JSON.stringify({
        Name: name, 
        State: state,
        City: city, 
        Signatory: 'Y',
        ID_Type: entitytype,
        Date_Sign: dateString, 
        LimitUsers: 0,
        CurrentUsers: 0,
        LimitCorpUsers: 0,
        CurrentCorpUsers: 0
      });
      url_api = BASE_URL + "/api/public"
    } else if (sector === 'private' || sector === 'other') { // Corrected 'else if' syntax and comparison
      body = JSON.stringify({
        Name: name,
        State: state,
        City: city,
        Signatory: 'Y',
        ID_Type: entitytype,
        Date_Sign: dateString,
        LimitUsers: 0,
        CurrentUsers: 0,
        LimitAccessGranted: 0,
        CurrentAccessGranted: 0
      });
      url_api = BASE_URL + "/api/private"
    }
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + login.token,
      },
      body:body
    };

    try {
      
      console.log(body)

      const response = await fetch(url_api, requestOptions);
     
      console.log('response fetch')
      console.log(response)
      
      const data = await response.json();
      
      if (!response.ok) {
          // Handle server-side errors
          console.log("Error Response:", data);
          setSnackbarMessage('Oops! an error happened during the sending request process');
          setSnackbarOpen(true);
          return { status: 'error', message: data.detail || 'An error occurred during registration.' };
      } else {
          // Handle successful registration
          console.log("Success Response:", data);
          // Optionally, you can adjust here if you need to return some success data
          setSnackbarMessage('Your request was sent succesfully!');
          setSnackbarOpen(true);
          cleanFormData()
          return { status: 'success', data: data };
      }
      

    } catch (error) {
      // Handle network errors or errors in the fetch operation itself
      console.error("Fetch Error:", error);
      setSnackbarOpen(true); // Open the snackbar to show the error message
      setSnackbarMessage('Network error or problem reaching the server.'); // Set the error message
      return { status: 'error', message: 'Network error or problem reaching the server.' };
    }
  };

  return (
    <Card >
      <CardHeader 
                  subheader="Fill this form to activate full access into the Dashboard Platform. All fields are required"
                  title="Request your KEY"
                  sx={{
                    '& .MuiCardHeader-subheader': {color: 'gray', fontSize: '11px'},
                    '& .MuiCardHeader-title': {color: 'white'},
                  }}></CardHeader>
      <CardContent>
         <form>
          
          <div>
            <Typography variant="h6" gutterBottom color="whitesmoke">
              Select a Sector from the options below *
            </Typography>
            <RadioGroup
              aria-label="sector"
              name="sector"
              value={sector}
              onChange={handleSectorChange}
              style={{ margin: '0.5rem', justifyContent: 'flex-end', width: '95%', color: 'whitesmoke' }}
            >
              <FormControlLabel value="private" control={<Radio sx={{ color: 'PowderBlue' }} />} label="Private Sector"/>
              <FormControlLabel value="public" control={<Radio sx={{ color: 'PowderBlue' }} />} label="Public Sector" />
              <FormControlLabel value="other" control={<Radio sx={{ color: 'PowderBlue' }} />} label="Other (student, academia, non profit, etc)" />
            
            </RadioGroup>
          </div>

          <TextField 
            label="Name of Entity or Community" 
              required
              value={name}
              onChange={(e)=>setName(e.target.value)} 
              sx={{
                margin: "0.5rem",
                justifyContent: "flex-end",
                width: "95%",
                '& .MuiInputBase-root': { borderBottom: '1px solid var(--main-color)', 
                  backgroundColor: 'PowderBlue', opacity: "75%" },
                '& .MuiInputLabel-root': { color: "white",  fontSize: '11px' },
                '& .MuiInputLabel-shrink::after': { color: 'white' },
            }} 
          />

          <Typography variant="h6" gutterBottom color="whitesmoke">
            Select Entity Type *
          </Typography>
              
          <Select
            labelId="entity-selector"
            id="entity-selector"
            value={entitytype}
            /*onChange={(e) => setEntityType(e.target.value)}*/
            onChange={handleEntityTypeChange}
            variant="outlined"
            style={{ margin: '0.5rem', width: '95%', color: 'white', backgroundColor: 'powderblue', opacity: '80%' }}
          >
            {sector === 'public' && [
                <MenuItem value={0}>City</MenuItem>,
                <MenuItem value={1}>University</MenuItem>,
                <MenuItem value={2}>Non profit</MenuItem>,
                <MenuItem value={3}>MPO</MenuItem>,
                <MenuItem value={4}>District</MenuItem>,
                <MenuItem value={5}>Other</MenuItem>
            ]}

            {(sector === 'private' || sector === 'other') && [
                <MenuItem value={0}>Consulting company</MenuItem>,
                <MenuItem value={1}>Non profit</MenuItem>,
                <MenuItem value={2}>Academia</MenuItem>,
                <MenuItem value={3}>Other</MenuItem>
            ]}

            
          </Select>
            
          <TextField 
            label="City" 
            required
            value = {city}
            onChange={(e)=>setCity(e.target.value)}
            sx={{
              margin: "0.5rem",
              justifyContent: "flex-end",
              width: "95%",
                '& .MuiInputBase-root': { borderBottom: '1px solid var(--main-color)', 
              backgroundColor: 'PowderBlue', opacity: "75%" },
                '& .MuiInputLabel-root': { color: "white",  fontSize: '11px' },
                '& .MuiInputLabel-shrink::after': { color: 'white' },
            }}/>

          <TextField 
            label="State / Region" 
            required
            value = {state}
            onChange={(e)=>setState(e.target.value)} 
            sx={{
              margin: "0.5rem",
              justifyContent: "flex-end",
              width: "95%",
                '& .MuiInputBase-root': { borderBottom: '1px solid var(--main-color)', 
              backgroundColor: 'PowderBlue', opacity: "75%" },
                '& .MuiInputLabel-root': { color: "white",  fontSize: '11px' },
                '& .MuiInputLabel-shrink::after': { color: 'white' },
          }}/>

          <TextField 
            type="number" label="Requesting this number of users with full access (tracking and reporting)" required inputProps={{ min: 1, max: 10 }} 
            value={numberusers}
            onChange={handleUserCountChange}
            sx={{
              margin: "0.5rem",
              justifyContent: "flex-end",
              width: "95%",
                '& .MuiInputBase-root': { borderBottom: '1px solid var(--main-color)', 
                  backgroundColor: 'PowderBlue', opacity: "75%" },
                '& .MuiInputLabel-root': { color: "white",  fontSize: '11px' },
                '& .MuiInputLabel-shrink::after': { color: 'white' },
            }}
            />
              {setNumberUsersError && (
                <Typography variant="body2" color="error">
                  {setNumberUsersError}
                </Typography>
              )}
                    
          {sector === 'public' && (
             <TextField 
              type="number" 
              label="Number of user you would like to grant access to your Strategies Data" fullWidth inputProps={{ min: 1, max: 10 }} 
              value={numberprivate}
              onChange={handleUserCountChange2}
              sx={{
              margin: "0.5rem",
              justifyContent: "flex-end",
              width: "95%",
              '& .MuiInputBase-root': { borderBottom: '1px solid var(--main-color)', 
                backgroundColor: 'PowderBlue', opacity: "75%" },
              '& .MuiInputLabel-root': { color: "white",  fontSize: '11px' },
              '& .MuiInputLabel-shrink::after': { color: 'white' },
            }}/>
            )}
            {numberprivateerror && (
              <Typography variant="body2" color="error">
                {numberprivateerror}
              </Typography>
            )}
            
            <Grid container justifyContent="flex-end" >
              <CardActions sx={{width:'100%'}}>

                <Button 
                  variant="outlined" 
                  fullWidth
                  onClick={submitRequestKey}
                  sx={{ width: '96%', color: 'var(--main-color)', border: '1px solid var(--main-color)' }}
                >
                  request key
                </Button>

              </CardActions>
            </Grid>

            <Snackbar
              open={snackbarOpen}
              autoHideDuration={6000} // Auto close after 6 seconds
              onClose={handleCloseSnackbar}
              message={snackbarMessage}
             />
            <br />

        </form>
        
      </CardContent>
    </Card>
  );
};

export default FormRequestKeys;
